import AvatarPillBtn from '../shared/AvatarPillBtn';
import HeaderDropdownBtn from '../shared/HeaderDropdownBtn';
import { useUserContext } from '../../providers/UserContext';
import { ReactComponent as PearsonLogo } from '../../assets/image/logo-pearson.svg';

function Header() {
  const { tutorByIesId } = useUserContext();
  return (
    <section className="header-section">
      <div className="logo">
        <PearsonLogo />
      </div>
      <div className="actions">
        <HeaderDropdownBtn btnTitle="Help" />

        {tutorByIesId && <AvatarPillBtn tutor={tutorByIesId} />}
      </div>
    </section>
  );
}

export default Header;
